import { useAction, useAtom } from '@reatom/npm-react'

import type { PurchaseBoostersReatom } from '@root/features/premium'
import type { PremiumApi } from '@root/shared/api'

export const usePaymentBoostersForm = ({
  model,
}: {
  model: PurchaseBoostersReatom
  type: PremiumApi.PurchaseTypeDto | 'extend'
}) => {
  const [miniumBoosters] = useAtom(model.miniumBoostersAtom)

  const [boosters] = useAtom(model.boostersCountAtom)
  const [boostersRaw] = useAtom(model.boostersCountAtom.raw)
  const setBoostersRaw = useAction(model.boostersCountAtom.setRaw)
  const [boostersPrice] = useAtom(model.boostersPriceNativeAtom)

  const handleValueClick = (n: number) => {
    const updatedValue = boosters.plus(n)
    if (updatedValue.lt(miniumBoosters)) {
      return
    }

    setBoostersRaw(updatedValue.toString())
  }

  return {
    boosters,
    boostersRaw,
    boostersPrice,
    miniumBoosters,
    setBoostersRaw,
    handleValueClick,
  }
}
